import {
  calculateMidNatForStockOption,
  calculateMidNatForOptionOption
} from '@/utils/optionChainServices/calculations/price';

export default {
  methods: {
    calculateMidAndNatFromLegs(firstLeg, secondLeg) {
      if (!firstLeg.isRicAvailable || !secondLeg.isRicAvailable) {
        return;
      }

      let firstMLOLeg = this.constructMLOLeg(firstLeg),
        secondMLOLeg = secondLeg ? this.constructMLOLeg(secondLeg) : null;

      if (firstMLOLeg.type === 'EQUITY') {
        return calculateMidNatForStockOption(firstMLOLeg, secondMLOLeg);
      } else {
        return calculateMidNatForOptionOption(firstMLOLeg, secondMLOLeg);
      }
    },
    calculateMidAndNat(firstLeg, secondLeg) {
      let ret = {};
      if ((!firstLeg || !firstLeg.isRicAvailable) && (!secondLeg || !!secondLeg.isRicAvailable)) {
        return ret;
      }

      let firstMLOLeg = this.constructMLOLeg(firstLeg),
        firstMLOPriceLeg = this.constructMLOLeg(firstLeg, 'q._TRDPRC_1', 'q._TRDPRC_1'),
        secondMLOLeg = secondLeg ? this.constructMLOLeg(secondLeg) : null,
        secondMLOPriceLeg = secondLeg ? this.constructMLOLeg(secondLeg, 'q._TRDPRC_1', 'q._TRDPRC_1') : null;

      if (firstMLOLeg.type === 'EQUITY') {
        ret = calculateMidNatForStockOption(firstMLOLeg, secondMLOLeg);
        const { mid } = calculateMidNatForStockOption(firstMLOPriceLeg, secondMLOPriceLeg);
        ret['mlPrice'] = mid;
      } else {
        ret = calculateMidNatForOptionOption(firstMLOLeg, secondMLOLeg);
        const { mid } = calculateMidNatForOptionOption(firstMLOPriceLeg, secondMLOPriceLeg);
        ret['mlPrice'] = mid;
      }
      return ret;
    },
    constructMLOLeg(order, bidFid = 'q._BID', askFid = 'q._ASK') {
      const toAction = action => {
        switch (action) {
          case ('BUY', 'BUY_TO_COVER'):
            return 'BUY';
          case ('SELL', 'SHORT_SELL'):
            return 'SELL';
          case ('SELL_TO_OPEN', 'SELL_TO_OPEN_UNCOVERED', 'SELL_TO_OPEN_UNCOVERED'):
            return 'SELL_TO_OPEN';
          default:
            return action;
        }
      };
      const actionType = () => {
        let buy = true;
        if (['BUY', 'BUY_TO_CLOSE', 'BUY_TO_OPEN'].includes(actionName)) buy = true;
        else buy = false;
        return {
          isBuy: () => buy,
          isSell: () => !buy
        };
      };
      const actionName = toAction(order.extendedTerms ? order.extendedTerms.orderAction : 'BUY');
      const getLotSize = () => {
        if (order.isRicAvailable && order.security.type === 'OPTION') {
          const lotSize = order['q.LOT_SIZE_A'];
          if (isNaN(lotSize)) return -1;
          return +lotSize;
        }
        return 1;
      };
      return {
        bid: +order[bidFid] || 0,
        ask: +order[askFid] || 0,
        action: actionName,
        actionType: actionType(),
        lotSize: getLotSize(),
        quantity: order.quantity,
        type: order.security ? order.security.type : 'EQUITY',
        order
      };
    }
  }
};
